import { render } from "./DeliveryView.vue?vue&type=template&id=3dd74208&scoped=true"
import script from "./DeliveryView.vue?vue&type=script&lang=js"
export * from "./DeliveryView.vue?vue&type=script&lang=js"

import "./DeliveryView.vue?vue&type=style&index=0&id=3dd74208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dd74208"]])

export default __exports__